import { enums, ILimitOrder } from '@kattana-io/common';
import { createSelector } from 'reselect';
import { IStore } from '../reducers';

const getWatchedLimitOrders = createSelector(
  (state: IStore) => state.limitOrders.orders || [],
  (orders: ILimitOrder[]): ILimitOrder[] =>
    orders.filter((item) => item.status == enums.LimitOrderStatus.WATCH)
);

export { getWatchedLimitOrders };
